export default "__VITE_ASSET__C9HY0q8l__"